import http from './http'
import config from '../config'

export default {
  auth: {
    login (username, password, tenant) {
      return http.post('/token?tenant=' + tenant, {
        grant_type: 'password',
        client_id: config.ClientId,
        userName: username,
        password: password
      })
    },
    register (model) {
      return http.post('/tenant/account/register', model)
    },
    getMenus () {
      return http.get('/auth/user/getmenus')
    },
    getMenuPermissions (menuid) {
      return http.get('/auth/user/getmenupermissions', {menuid: menuid})
    },
    getConfigs () {
      return {productGrade: 6}
    },
    getCurrentUserInfo () {
      return http.get('/auth/user/getcurrentuserinfo')
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js